<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: xjf
 * @LastEditTime: 2024-11-11 10:42:27
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>任务详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTab">
        <div class="detail">
          <div class="itemBox">
            <el-tabs type="card" value="first">
              <el-tab-pane label="任务信息" name="first">
                <div class="iemBoxContent">
                  <div class="modelTitle">任务详情</div>
                  <div class="infoItem">
                    <div class="infoTitle">编号：</div>
                    <div>{{ detail.jobNo }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">接单类型：</div>
                    <div v-if="detail.applyType == 0">所有</div>
                    <div v-if="detail.applyType == 1">企业</div>
                    <div v-if="detail.applyType == 2">临勤</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">发布人：</div>
                    <div>{{ detail.creatorName }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">创建时间：</div>
                    <div>{{ detail.gmtCreate }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">发布范围：</div>
                    <div>{{ detail.rangeName }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">任务名称：</div>
                    <div>{{ detail.title }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">任务地址：</div>
                    <div>{{ detail.address }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">订单状态：</div>
                    <div v-if="detail.status == 0">待支付</div>
                    <div v-if="detail.status == 1">待发布</div>
                    <div v-if="detail.status == 2">发布中</div>
                    <div v-if="detail.status == 3">已收单</div>
                    <div v-if="detail.status == 4">实做中</div>
                    <div v-if="detail.status == 5">已取消</div>
                    <div v-if="detail.status == 6">已结算</div>
                    <div v-if="detail.status == 8">已完成</div>
                    <div v-if="detail.status == 9">已关闭</div>
                  </div>
                  <div class="infoItem" v-if="detail.status == 5">
                    <div class="infoTitle">取消原因：</div>
                    <div>{{ detail.cancelReason }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">发布时间：</div>
                    <div>{{ detail.actionAt }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">需求人数：</div>
                    <div>{{ detail.membersNum }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">用户任务单价：</div>
                    <div>{{ detail.customUnitPrice }}元/小时</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">身高要求：{{ detail.highName }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">职业要求：{{ detail.careerTypeName }}-{{ detail.levelTypeName }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">着装要求：{{ detail.dressTypeName }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">年龄要求：{{ detail.ageTypeName }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">用工场景：{{ detail.employSceneTypeName }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">任务金额：</div>
                    <div>￥{{ detail.price }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">任务退款：</div>
                    <div>￥{{ detail.returnFee }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">保安预期收益：</div>
                    <div>￥{{ detail.expectedSecPrice }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">保安结算金额：</div>
                    <div>￥{{ detail.settledAmount }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">保安扣款：</div>
                    <div>￥{{ detail.reductionAmount }}</div>
                  </div>
                  <div class="borderBottom"></div>
                  <div class="infoItem">
                    <div class="infoTitle">平台预期服务费：</div>
                    <div>￥{{ detail.platformServiceFee }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">平台实际结算：</div>
                    <div>￥{{ detail.platformSettledAmount }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">平台服务费（挂帐）：</div>
                    <div>￥{{ detail.platformReductionAmount }}</div>
                  </div>
                  <div class="borderBottom"></div>
                  <div class="modelTitle">服务时长</div>
                  <div class="infoItem">
                    <div class="infoTitle">总时长：</div>
                    <div>{{ detail.hour }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">实做时间：</div>
                    <div>{{ detail.jobStart }}至{{ detail.jobEnd }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">服务分班：</div>
                    <div>{{ detail.num }}班</div>
                  </div>
                  <div
                    class="infoItem"
                    v-for="(item, index) in detail.jobScheduleList"
                    :key="index"
                  >
                    <div class="infoTitle">
                      {{
                        item.scheduleType == 0
                          ? "早班"
                          : item.scheduleType == 1
                          ? "中班"
                          : "夜班"
                      }}：
                    </div>
                    <div>{{ item.startTime }}-{{ item.endTime }}</div>
                  </div>
                  <div>
                  <div class="borderBottom"></div>
                  <div class="modelTitle">支付详情</div>
                  <div class="infoItem">
                    <div class="infoTitle">第三方支付流水号：</div>
                    <div >  {{ detail.billDetail?detail.billDetail.thirdPaymentOrder:'无' }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">平台单号：</div>
                    <div >  {{ detail.billDetail?detail.billDetail.paymentOrder:'无' }}</div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">支付方式：</div>
                    <div>
                      {{
                        detail.payWay == 0
                          ? "钱包"
                          : detail.payWay == 2
                          ? "银行卡"
                          : detail.payWay == 3
                          ? "支付宝"
                          : detail.payWay == 4
                          ? "微信"
                          : "无"
                      }}
                    </div>
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">支付状态：</div>
                    <div>
                      {{
                        detail.payStatus == 0
                          ? "待支付"
                          : detail.payStatus == 1
                          ? "已支付"
                          : "无"
                      }}
                    </div>
                  </div>

                  <div class="infoItem">
                    <div class="infoTitle">结算状态：</div>
                    <div v-if="detail.cashType == 0">未结算</div>
                    <div v-if="detail.cashType == 1">结算中</div>
                    <div v-if="detail.cashType == 2">已结算</div>
                    <!-- <div v-if="detail.cashType == 3">
                      投诉处理中
                    </div> -->
                  </div>
                  <div class="infoItem">
                    <div class="infoTitle">退款状态：</div>
                    <div v-if="detail.refundStatus == 0">无退款</div>
                    <div v-if="detail.refundStatus == 1">处理中</div>
                    <div v-if="detail.refundStatus == 2">已完成</div>
                  </div>
                  <div class="infoItem" v-if="detail.refundStatus == 2">
                    <div class="infoTitle">退款时间：</div>
                    <div>{{ detail.refundAt }}</div>
                  </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="itemBox">
            <el-tabs type="card" value="first" @tab-click="handleClick1" v-model="activeName1">
              <el-tab-pane label="抢单人员列表" name="0"
                ><div class="iemBoxContent">
                  <div
                    class="detail"
                    style="align-items: center;margin-bottom: 10px;"
                  >
                    <div>已抢单人数{{ total }}</div>
                  </div>
                  <div
                    v-for="(item, index) in tableData9"
                    :key="index"
                    :class="[
                      'listItem',
                      selectData.bodyguardId == item.bodyguardId ? 'active' : ''
                    ]"
                    @click="select(item)"
                  >
                    <div class="img">
                      <img :src="item.headimgUrl || require('@/assets/imgs/headImg.png')" alt="" />
                    </div>
                    <div>{{ item.bodyguardName || item.name}}</div>
                    <div v-if="item.status == 2" style="flex: none;">({{ item.statusName }})</div>
                  </div>
                  <el-pagination
                      layout="prev, pager, next"
                      :total="total"
                      @current-change="jobApplicationList"
                      small
                    >
                    </el-pagination></div
              ></el-tab-pane>
              <el-tab-pane label="实做人员列表" name="1"
                ><div class="iemBoxContent">
                  <div class="detail" style="align-items: center;">
                    <div>
                      共需{{ detail.membersNum }}人，已加入{{
                        people
                      }}人，已取消{{detail.cancelNum || '0'}}人
                    </div>
                    <el-button type="primary" @click="add">{{
                      edit ? "保存" : "编辑"
                    }}</el-button>
                  </div>
                  <div
                    v-for="(item, index) in jobWorkList"
                    :key="index"
                    :class="[
                      'listItem',
                      selectData.bodyguardId == item.bodyguardId ? 'active' : ''
                    ]"
                    @click="select(item)"
                  >
                    <div class="img">
                      <img :src="item.headimgUrl || require('@/assets/imgs/headImg.png')" alt="" />
                    </div>
                    <div>
                      <div>{{ item.name }}</div>
                      <div >{{item.workStatusName}}</div>
                    </div>
                    <div style="text-align: center;margin-left: auto;">
                      <div>沟通记录</div>
                      <div>{{ item.interactNum }}</div>
                    </div>
                    <img src="../../assets/imgs/icon_right.png" alt="" />
                  </div>
                  <el-button
                    v-if="edit"
                    size="small"
                    @click="addlist"
                    style="width:100px;font-size: 28px;margin: 20px 80px 0;display: inline-block;"
                    >+</el-button
                  >
                   <el-pagination
                      layout="prev, pager, next"
                      :total="people"
                      @current-change="baoanHandleCurrentChange"
                      small
                    >
                    </el-pagination>
                </div></el-tab-pane
              >
              <el-tab-pane label="变更记录" name="2"
                ><div class="iemBoxContent">
                  <el-table ref="scrollTable":data="tableData" style="width: 100%">
                    <el-table-column prop="id" label="编号"> </el-table-column>
                    <el-table-column prop="sourceBodyguardName" label="原人员">
                    </el-table-column>
                    <el-table-column prop="replaceBodyguardName" label="变更">
                    </el-table-column>
                    <el-table-column prop="reason" label="原因">
                    </el-table-column>
                    <el-table-column prop="gmtCreate" label="时间">
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 50]"
                    :page-size="pageSize"
                    layout="total, prev, pager, next,sizes"
                    :total="total"
                  >
                  </el-pagination></div
              ></el-tab-pane>
            </el-tabs>
          </div>
          <div class="itemBox">
            <el-tabs type="card" @tab-click="handleClick" v-model="activeName">
              <el-tab-pane label="沟通记录" name="0"
                ><div class="iemBoxContent" style="overflow-y: scroll;">
                  <el-select
                    style="margin-right: auto;margin-bottom: 10px;"
                    placeholder="请选择消息发出人"
                    v-if="selectData && selectData.imType == 0"
                    v-model="selectPeople"
                     ref="select"
                    filterable
                    @visible-change="handleVisibleChange"
                    @change="communicateList"
                  >
                    <el-option :label="item.name" :value="item.memberId" v-for="(item,index) in peopleList" :key="index"></el-option>
                  </el-select>
                  <div v-if="tableData1.length>0" v-for="(item, index) in tableData1" :key="index">
                    <div class="communicate" v-if="item.isSend == 0">
                      <div style="display: flex;">
                        <div class="img">
                          <!-- <img :src="selectData.headimgUrl" alt="" /> -->
                          <img :src="item.senderAvatar || require('@/assets/imgs/headImg.png')" alt="" />
                        </div>
                        <div>
                          {{ item.gmtCreate }}
                        </div>
                        <div style="margin-left: auto;">
                          {{ item.senderName }}（{{
                            item.senderType == 1
                              ? "客户"
                              : item.senderType == 2
                              ? "临勤"
                              : item.senderType == 3
                              ? "保安公司"
                              : item.senderType == 4
                              ? "保安公司员工"
                              : "平台客服"
                          }}）
                        </div>
                      </div>
                      <div style="text-align: left;">
                      <div class="message" v-if="item.message.type == 0 ||item.message.type == 2||item.message.type == 3||item.message.type == 4||item.message.type == 5||item.message.type == 6">
                        {{ item.message.context }}
                      </div>
                      <div class="message" v-if="item.message.type == 1">
                          <el-image
    :src="item.message.context" alt="" style="width: 200px;height: 200px;"
    :preview-src-list="[item.message.context]">
  </el-image>
                      </div>
                     <!-- 任务 -->
                    <div
                      v-if="item.message.type == 7"
                      @click="goJob(item.message.id)"
                      class="pointer"
                    >
                      <el-card class="box-card1 other">
                        <div class="cardTop">
                          <div class="cardNum">
                            任务编号：{{ item.message.jobNo }}
                          </div>
                          <div class="cardStatus">
                            <span v-if="item.message.status == 0">待支付</span>
                            <span v-if="item.message.status == 1">待发布</span>
                            <span v-if="item.message.status == 2">发布中</span>
                            <span v-if="item.message.status == 3">已收单</span>
                            <span v-if="item.message.status == 4">实做中</span>
                            <span v-if="item.message.status == 5">已取消</span>
                            <span v-if="item.message.status == 6">已结算</span>
                          </div>
                        </div>
                        <div style="margin-top: 5px;">
                          任务名称：{{ item.message.jobName }}
                        </div>
                        <div style="margin-top: 5px;">
                          地址：{{ item.message.address }}
                        </div>
                        <div style="margin-top: 5px;">
                          时间：{{ item.message.jobStart }}-{{ item.message.jobEnd }}
                        </div>
                        <div class="cardTop" style="margin-top: 5px;">
                          <div class="cardNum">
                            单价：￥{{ item.message.unitPrice }}
                          </div>
                          <div class="cardNum">
                            任务时长：{{ (item.message.hour * 60) | maxTime }}
                          </div>
                          <div class="cardNum">
                            总金额：￥{{ item.message.price }}
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <!-- 投诉 -->
                    <div
                      v-if="item.message.type == 8"
                      @click="gocomplaint(item.message.jobComplainId)"
                      class="pointer"
                    >
                      <el-card class="box-card1 other">
                        <div class="cardTop">
                          <div class="cardNum">
                            投诉编号：{{ item.message.complainNo }}
                          </div>
                          <div class="cardStatus">
                            <span v-if="item.message.jobComplainStatus == 0"
                              >未处理</span
                            >
                            <span v-if="item.message.jobComplainStatus == 1"
                              >已处理</span
                            >
                            <span v-if="item.message.jobComplainStatus == 2"
                              >已撤销</span
                            >
                          </div>
                        </div>
                        <div style="margin-top: 5px;">
                          任务名称：{{ item.message.jobName }}
                        </div>
                        <div style="margin-top: 5px;">
                          被投诉人名称：{{ item.message.respondentName }}
                        </div>
                        <div style="margin-top: 5px;">
                          投诉人名称：{{ item.message.complainantName }}
                        </div>
                        <div style="margin-top: 5px;">
                          投诉原因：{{ item.message.complainMemo }}
                        </div>
                        <div class="cardTop" style="margin-top: 5px;">
                          <div class="cardNum">
                            提交时间：{{ item.message.submitAt }}
                          </div>
                          <div class="cardNum">
                            责任人类型：{{
                              item.message.dutyType == 1
                                ? "用户"
                                : item.message.dutyType == 2
                                ? "保安(临勤)"
                                : "保安(公司)"
                            }}
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <!-- 违约 -->
                    <div
                      v-if="item.message.type == 9"
                      @click="godefault(item.message.violateLogId)"
                      class="pointer"
                    >
                      <el-card class="box-card1 other">
                        <div class="cardTop">
                          <div class="cardNum">
                            违约编号：{{ item.message.violateLogNo }}
                          </div>
                          <div class="cardStatus">
                            {{
                              item.message.violateLogStatus == 0
                                ? "待支付"
                                : "已支付"
                            }}
                          </div>
                        </div>
                        <div style="margin-top: 5px;">
                          任务名称：{{ item.message.jobName }}
                        </div>
                        <div style="margin-top: 5px;">
                          违约类型：{{ item.message.voilateTypeTitle }}
                        </div>
                        <div style="margin-top: 5px;">
                          违约规则：{{ item.message.voilateMemo }}
                        </div>
                        <div class="cardTop" style="margin-top: 5px;">
                          <div class="cardNum">
                            违约：￥{{ item.message.violateAmount }}
                          </div>
                          <div class="cardNum">
                            退还：￥{{ item.message.refundAmount || 0 }}
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <!-- 考勤 -->
                    <div
                      v-if="item.message.type == 10"
                      @click="goappeal(item.message.appealId)"
                      class="pointer"
                    >
                      <el-card class="box-card1 other">
                        <div class="cardTop">
                          <div class="cardNum">
                            考勤申诉编号：{{ item.message.appealNo }}
                          </div>
                          <div class="cardStatus">
                            <span>{{ item.message.operateStatusTitle }}</span>
                          </div>
                        </div>
                        <div style="margin-top: 5px;">
                          任务名称：{{ item.message.jobName }}
                        </div>
                        <div style="margin-top: 5px;">
                          考勤日期：{{ item.message.dueAtIn }}-{{
                            item.message.dueAtOut
                          }}
                        </div>
                        <div style="margin-top: 5px;">
                          打卡状态：{{ item.message.signStatusTitle }}
                        </div>
                        <div style="margin-top: 5px;">
                          申诉原因：{{ item.message.appealReason }}
                        </div>
                      </el-card>
                    </div>
                    </div>
                    </div>
                    <div class="communicate" v-if="item.isSend == 1">
                      <!-- <div style="display: flex;" v-if="item.receiverType == 6">
                        <div class="img">
                          <img :src="item.senderAvatar || require('@/assets/imgs/headImg.png')" alt="" />
                        </div>
                        <div>
                          {{ item.gmtCreate }}
                        </div>
                        <div style="margin-left: auto;">
                          {{ item.senderName }}（{{
                            item.senderType == 1
                              ? "客户"
                              : item.senderType == 2
                              ? "临勤"
                              : item.senderType == 3
                              ? "保安公司"
                              : item.senderType == 4
                              ? "保安公司员工"
                              : "平台客服"
                          }}）
                        </div>
                      </div> -->
                      <div style="display: flex;">
                        <div style="margin-right: auto;">
                          {{ item.gmtCreate }}
                        </div>
                        <div style="margin-right: 10px;">
                          {{ item.senderName }}（{{
                            item.senderType == 1
                              ? "客户"
                              : item.senderType == 2
                              ? "临勤"
                              : item.senderType == 3
                              ? "保安公司"
                              : item.senderType == 4
                              ? "保安公司员工"
                              : "平台客服"
                          }}）
                        </div>
                        <div class="img" style="margin-right: 0;">
                          <img :src="item.senderAvatar|| require('@/assets/imgs/headImg.png')" alt="" />
                        </div>
                      </div>
                      <div style="text-align: right;">
                       <div class="message" v-if="item.message.type == 0 ||item.message.type == 2||item.message.type == 3||item.message.type == 4||item.message.type == 5||item.message.type == 6">
                        {{ item.message.context }}
                      </div>
                      <div class="message" v-if="item.message.type == 1">
                         <el-image
    :src="item.message.context" alt="" style="width: 200px;height: 200px;"
    :preview-src-list="[item.message.context]">
  </el-image>
                      </div>
                     <!-- 任务 -->
                    <div
                      v-if="item.message.type == 7"
                      @click="goJob(item.message.id)"
                      class="pointer"
                    >
                      <el-card class="box-card1 other">
                        <div class="cardTop">
                          <div class="cardNum">
                            任务编号：{{ item.message.jobNo }}
                          </div>
                          <div class="cardStatus">
                            <span v-if="item.message.status == 0">待支付</span>
                            <span v-if="item.message.status == 1">待发布</span>
                            <span v-if="item.message.status == 2">发布中</span>
                            <span v-if="item.message.status == 3">已收单</span>
                            <span v-if="item.message.status == 4">实做中</span>
                            <span v-if="item.message.status == 5">已取消</span>
                            <span v-if="item.message.status == 6">已结算</span>
                          </div>
                        </div>
                        <div style="margin-top: 5px;">
                          任务名称：{{ item.message.jobName }}
                        </div>
                        <div style="margin-top: 5px;">
                          地址：{{ item.message.address }}
                        </div>
                        <div style="margin-top: 5px;">
                          时间：{{ item.message.jobStart }}-{{ item.message.jobEnd }}
                        </div>
                        <div class="cardTop" style="margin-top: 5px;">
                          <div class="cardNum">
                            单价：￥{{ item.message.unitPrice }}
                          </div>
                          <div class="cardNum">
                            任务时长：{{ (item.message.hour * 60) | maxTime }}
                          </div>
                          <div class="cardNum">
                            总金额：￥{{ item.message.price }}
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <!-- 投诉 -->
                    <div
                      v-if="item.message.type == 8"
                      @click="gocomplaint(item.message.jobComplainId)"
                      class="pointer"
                    >
                      <el-card class="box-card1 other">
                        <div class="cardTop">
                          <div class="cardNum">
                            投诉编号：{{ item.message.complainNo }}
                          </div>
                          <div class="cardStatus">
                            <span v-if="item.message.jobComplainStatus == 0"
                              >未处理</span
                            >
                            <span v-if="item.message.jobComplainStatus == 1"
                              >已处理</span
                            >
                            <span v-if="item.message.jobComplainStatus == 2"
                              >已撤销</span
                            >
                          </div>
                        </div>
                        <div style="margin-top: 5px;">
                          任务名称：{{ item.message.jobName }}
                        </div>
                        <div style="margin-top: 5px;">
                          被投诉人名称：{{ item.message.respondentName }}
                        </div>
                        <div style="margin-top: 5px;">
                          投诉人名称：{{ item.message.complainantName }}
                        </div>
                        <div style="margin-top: 5px;">
                          投诉原因：{{ item.message.complainMemo }}
                        </div>
                        <div class="cardTop" style="margin-top: 5px;">
                          <div class="cardNum">
                            提交时间：{{ item.message.submitAt }}
                          </div>
                          <div class="cardNum">
                            责任人类型：{{
                              item.message.dutyType == 1
                                ? "用户"
                                : item.message.dutyType == 2
                                ? "保安(临勤)"
                                : "保安(公司)"
                            }}
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <!-- 违约 -->
                    <div
                      v-if="item.message.type == 9"
                      @click="godefault(item.message.violateLogId)"
                      class="pointer"
                    >
                      <el-card class="box-card1 other">
                        <div class="cardTop">
                          <div class="cardNum">
                            违约编号：{{ item.message.violateLogNo }}
                          </div>
                          <div class="cardStatus">
                            {{
                              item.message.violateLogStatus == 0
                                ? "待支付"
                                : "已支付"
                            }}
                          </div>
                        </div>
                        <div style="margin-top: 5px;">
                          任务名称：{{ item.message.jobName }}
                        </div>
                        <div style="margin-top: 5px;">
                          违约类型：{{ item.message.voilateTypeTitle }}
                        </div>
                        <div style="margin-top: 5px;">
                          违约规则：{{ item.message.voilateMemo }}
                        </div>
                        <div class="cardTop" style="margin-top: 5px;">
                          <div class="cardNum">
                            违约：￥{{ item.message.violateAmount }}
                          </div>
                          <div class="cardNum">
                            退还：￥{{ item.message.refundAmount || 0 }}
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <!-- 考勤 -->
                    <div
                      v-if="item.message.type == 10"
                      @click="goappeal(item.message.appealId)"
                      class="pointer"
                    >
                      <el-card class="box-card1 other">
                        <div class="cardTop">
                          <div class="cardNum">
                            考勤申诉编号：{{ item.message.appealNo }}
                          </div>
                          <div class="cardStatus">
                            <span>{{ item.message.operateStatusTitle }}</span>
                          </div>
                        </div>
                        <div style="margin-top: 5px;">
                          任务名称：{{ item.message.jobName }}
                        </div>
                        <div style="margin-top: 5px;">
                          考勤日期：{{ item.message.dueAtIn }}-{{
                            item.message.dueAtOut
                          }}
                        </div>
                        <div style="margin-top: 5px;">
                          打卡状态：{{ item.message.signStatusTitle }}
                        </div>
                        <div style="margin-top: 5px;">
                          申诉原因：{{ item.message.appealReason }}
                        </div>
                      </el-card>
                    </div>
                    </div>
                    </div>
                  </div>
                  <div v-if="tableData1.length == 0" style="text-align: center;margin: 50px auto;">暂无数据</div>
                </div>
                <el-pagination
                      layout="prev, pager, next"
                      :total="listNum"
                      :page-size="pageSize1"
                      @current-change="moreList"
                      small
                    >
                    </el-pagination>
                </el-tab-pane
              >
              <el-tab-pane label="打卡记录" name="1">
                <div class="daka" v-if="tableData2.length > 0">
                  <el-timeline>
                    <el-timeline-item
                      :timestamp="item.timestamp"
                      placement="top"
                      v-for="(item, index) in tableData2"
                      :key="index"
                    >
                      <el-card >
                        <div style="display: flex;justify-content: space-between;align-items: center;">
                          <div>
                          <h4>第{{ item.dayNum }}天({{ item.signDay}})</h4>
                          <p>
                            <div v-for="(subItem, index) in item.signItemList" :key="index">
                              {{ subItem.signType == 0 ? "上班打卡" : "下班打卡" }} {{ subItem.realSignTime }} (<span v-html="getSignStatusName(subItem.signStatus)"></span> )
                            </div>
                           </p>
                        </div>
                        <el-button @click="correct(item)" v-if="detail.status != 5 && (!item.signItemList[0].realSignTime || !item.signItemList[1].realSignTime || item.signItemList[0].signStatus == -1)" type="primary" class="btn" style="height: 30px;line-height: 6px;">修正</el-button>
                        </div>
                      </el-card>
                    </el-timeline-item>
                  </el-timeline>
                </div>
                 <div v-if="tableData2.length == 0" style="text-align: center;margin: 50px auto;">暂无数据</div>
                </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
    <!-- 派单弹窗 -->
    <el-dialog
      title="考勤修正"
      :visible.sync="dialogFormVisible"
      :before-close="handleClose"
      width="500px"
    >
    <div v-if="selectData2.signItemList">请确认是否要对【{{selectData.bodyguardName}} {{selectData2.signDay}} (第{{selectData2.dayNum}}天)】考勤进行修正，修正后他的考勤和结算金额将改成正常</div>
      <div style="margin-top: 30px;text-align: right;">
        <el-button type="primary" @click="confrimCorrect" class="btn" style="margin: 0 auto;display: block;"
          >修正保存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="派单设置"
      :visible.sync="dialogFormVisible1"
      width="800px"
    >
      <el-form ref="ruleForm" :model="ruleForm2">
        <el-row :gutter="4">
          <el-col :span="6">
            <el-form-item>
              <el-input
                v-model="ruleForm2.name"
                placeholder="请输入名称"
                @focus="clearData"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-input
                v-model="ruleForm2.phone"
                placeholder="请输入手机号"
                @focus="clearData"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="身份状态">
              <el-select v-model="ruleForm2.status" placeholder="请选择">
                <el-option
                  v-for="item in tableData4"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-button type="primary" @click="getUserList()" class="btn"
                >查询</el-button
              >
              <el-button @click="resetForm1()">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="margin-bottom: 20px;">
        需求人数：{{ detail.membersNum }}，已参与人数：{{ detail.readiesNum }}
      </div>
      <div style="margin-bottom: 20px;">搜索总数：{{ tableData3.length }}</div>
      <el-table
        ref="singleTable"
        :data="tableData3"
        style="width: 100%"
        highlight-current-row
        @current-change="selectItem"
        max-height="250"
      >
        <el-table-column align="center" width="50">
          <template slot-scope="scope">
            <div
              :class="[scope.row.id == selectUserID ? 'select' : 'noselect']"
            ></div>
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">{{
            scope.row.accountType == 0
              ? scope.row.companyName
              : scope.row.cardName
          }}</template>
        </el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">{{
            scope.row.accountType == 0
              ? "企业"
              : scope.row.accountType == 0
              ? "企业员工"
              : "临勤"
          }}</template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 30px;text-align: right;">
        <el-button type="primary" @click="allocation()" class="btn"
          >派单</el-button
        >
        <el-button @click="resetForm2()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system
  },
  data() {
    return {
      leftList: this.Plugins.taskData(),
      editId: "",
      detail: {
        "billDetail" : {
          "paymentOrder":"",
        },
        "jobApplicationList": [],
        "jobWorkList": []
      },
      activeName: "0",
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [], // 变更记录
      tableData4: [
        { label: "企业", value: "0" },
        { label: "临勤", value: "2" }
      ],
      page1: 1,
      pageSize1: 30,
      page2: 1,
      pageSize2: 10,
      activeName1: 0,
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData9: [],
      jobWorkList: [],// 实做人员列表
      selectData: {}, // 选择的保安的沟通记录
      edit: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      ruleForm2: {
        name: "",
        phone: "",
        status: ""
      },
      selectUserID: "",
      allocationId: "",
      activeName1: 0,
      peoplePage:1,
      peoplePageSize:10,
      selectData1: {}, // 点击派单时选择的数据
      people: 0, // 实作人员列表已加入人数
      selectData2: {}, // 点击修正选择的数据
      peopleList:[], // 聊天筛选人员列表
      selectPeople:'', // 聊天筛选人员列表
      listNum:0,
      hasMore: true,   // 是否还有更多数据
      loading: false,  // 防止重复加载
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.getDetail1();
    }
  },
  methods: {
    moreList(val){
      this.page1 = val;
      this.communicateList()
    },
    // 初始加载 + 滚动加载
    loadMore() {
      if (this.loading || !this.hasMore) return;
      this.loading = true;
      // 模拟异步请求（实际中替换为 API 调用）
      setTimeout(() => {
      const newData = this.tableData1;
      let param = {
        page: this.page2,
        pageSize: this.pageSize2,
        bodyguardId: this.selectData.bodyguardId,
        jobNo: this.detail.jobNo
      };
      this.$axios
        .post(`/admapi/job/chatmemberlist`, param)
        .then(({ data }) => {
          newData.push(...data.items)
          this.peopleList = newData
          this.loading = false;
          if(data.items.length<this.pageSize2){
            this.hasMore = false
          }
        })
        .catch()
        .finally();

      }, 500);
    },
    // 监听下拉框展开/关闭
    handleVisibleChange(open) {
      if (open) {
        this.$nextTick(() => {
          this.bindScrollEvent();
        });
      }
    },
    // 绑定滚动事件
    bindScrollEvent() {
      const dropdown = this.$refs.select.$refs.popper.$el;
      // 获取下拉菜单中的滚动容器（.el-select-dropdown__wrap）
      const scrollWrap = dropdown.querySelector('.el-select-dropdown__wrap');
      if (!scrollWrap) return;

      // 移除旧事件，防止重复绑定
      scrollWrap.removeEventListener('scroll', this.handleScroll);
      scrollWrap.addEventListener('scroll', this.handleScroll);
    },
    // 滚动处理函数
    handleScroll() {
      const wrap = this.$refs.select.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
      if (!wrap) return;
      const { scrollTop, clientHeight, scrollHeight } = wrap;
      // 判断是否滚动到底部（允许 5px 误差）
      if (scrollHeight - scrollTop - clientHeight < 5 && !this.loading && this.hasMore == true) {
        this.page2 = this.page2+1;
        this.loadMore();
      }
    },
    goappeal(val) {
      let routeUrl = this.$router.resolve({
        path: "/appealDetail",
        query: {
          id: val
        }
      });
      window.open(routeUrl.href, "_blank");
    },
    goJob(val) {
      let routeUrl = this.$router.resolve({
        path: "/taskDetail",
        query: {
          id: val
        }
      });
      window.open(routeUrl.href, "_blank");
    },
    gocomplaint(val) {
      let routeUrl = this.$router.resolve({
        path: "/complaintAdd",
        query: {
          id: val,
          isDetail: 1
        }
      });
      window.open(routeUrl.href, "_blank");
    },
    godefault(val) {
      let routeUrl = this.$router.resolve({
        path: "/defaultDetail",
        query: {
          id: val
        }
      });
      window.open(routeUrl.href, "_blank");
    },
    jobApplicationList(val) {
      this.peoplePage = val;
      this.getJobList9();
    },
    baoanHandleCurrentChange(val) {
      this.peoplePage = val;
      this.getJobList();
    },
    handleClose(){
      this.selectData2 = {}
      this.dialogFormVisible = false
    },
    correct(val){
      this.selectData2 = val
      this.dialogFormVisible = true
    },
    confrimCorrect(){
      let param = {
        bodyguardId:this.selectData.bodyguardId,
        dayNum:this.selectData2.dayNum,
        jobNo:this.detail.jobNo,
      }
      this.$axios
        .post(`/admapi/job/signrevise`,param)
        .then(({ data }) => {
          console.log(data)
          this.$message({
            message: "修改成功",
            type: "success"
          });
          this.tableData2 = data
           this.dialogFormVisible = false
        })
        .catch()
        .finally();

    },
    add() {
      this.edit = !this.edit;
    },
    addlist() {
      this.getUserList();
    },
    clearData() {
      this.selectUserID = "";
      this.$refs.singleTable.clearSelection();
    },
    // 派单弹窗关闭
    resetForm2() {
      this.selectUserID = "";
      this.allocationId = "";
      this.ruleForm2.name = "";
      this.ruleForm2.status = "";
      this.ruleForm2.phone = "";
      this.dialogFormVisible1 = false;
    },
    // 选择派单人
    selectItem(val) {
      this.selectUserID = val == null ? "" : val.id;
    },
    //取消派单
    resetForm1() {
      this.selectUser = {};
      this.ruleForm2.name = "";
      this.ruleForm2.phone = "";
      this.ruleForm2.status = "";
      this.getUserList();
    },
    getUserList() {
      let param = {
        page: 1,
        pageSize: 1000,
        accountType: this.ruleForm2.status,
        cardName: this.ruleForm2.name,
        phone: this.ruleForm2.phone,
        jobNo: this.detail.jobNo
      };
      this.$axios
        .post(`/admapi/bodyguard/dispathMemberlist`, param)
        .then(({ data }) => {
          this.tableData3 = data.items;
          this.selectUserID = "";
          this.dialogFormVisible1 = true;
        })
        .catch()
        .finally();
    },
    // 点击派单提交
    allocation() {
      if (!this.selectUserID) {
        this.$message({
          message: "请选择保安",
          type: "warning"
        });
        return;
      }
      let param = {
        jobId: this.editId,
        bodygurardId: this.selectUserID
      };
      this.$axios
        .post(`/admapi/dispatchjob/add`, param)
        .then(({ data }) => {
          this.$message({
            message: "派单成功",
            type: "success"
          });
          if (this.selectModel == 3) {
            this.intercept();
          } else if (this.selectModel == 4) {
            this.waitdispatchlist();
          } else {
            this.dispatchlist();
          }
        })
        .catch()
        .finally(() => {
          this.selectUserID = "";
          this.allocationId = "";
          this.dialogFormVisible1 = false;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getDetail1() {
      this.$axios
        .post(`/admapi/job/get/${this.editId}`, { jobId: this.editId })
        .then(({ data }) => {
          if (data.jobScheduleList.length > 0) {
            data.num = data.jobScheduleList.length;
          } else {
            data.num = "暂无分";
          }
          this.detail = data;
          this.getList9()
        })
        .catch()
        .finally();
    },
    //沟通记录  ----   打卡记录
    handleClick(tab) {
      if (tab.index == 0) {
        this.loadMore()
        this.activeName = "0";
      } else {
        this.clock();
        this.activeName = "1";
      }
    },
    //列表切换
    handleClick1(tab) {
      this.activeName1 = tab.index;
      this.page = 1;
      this.pageSize = 10;
      this.total = 0;
       if(tab.index == 0){
        this.getList9()
        this.tableData9 = []
       }else if(tab.index == 1){
        this.tableData1 = []
        this.getJobList()
       }else{
        this.getList()
        this.tableData = []
       }
       this.activeName1 = tab.index;
       this.activeName = "0";
       this.tableData2 = [];
    },
    //实做人员列表
    getJobList(){
      let param = {
        page: this.peoplePage,
        pageSize: this.peoplePageSize,
        jobNo: this.detail.jobNo
      };
      this.$axios
        .post(`/admapi/job/jobworklist`, param)
        .then(({ data }) => {
          this.jobWorkList = data.items;
          this.people = data.page.totalRows
          this.selectData = data.items[0];
          if(data.items.length>0){
           if(this.selectData.imType == 0){
             this.loadMore()
           }else{
             this.communicateList();
           }
           }
        })
        .catch()
        .finally();
    },
    //抢单人员列表
    getList9() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        jobNo: this.detail.jobNo
      };
      this.$axios
        .post(`/admapi/job/jobapplicationlist`, param)
        .then(({ data }) => {
          this.tableData9 = data.items;
          this.peopleList = data.items;
          this.selectData = data.items[0];
          this.total = data.page.totalRows;
          if(data.items.length>0){
            if(this.selectData.imType == 0){
             this.loadMore()
           }else{
             this.communicateList();
           }
          }
        })
        .catch()
        .finally();
    },
    //变更记录列表
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        jobId: this.editId
      };
      this.$axios
        .post(`/admapi/job/changerecord`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
          if(data.items.length>0){
          if(this.selectData.imType == 0){
             this.loadMore()
           }else{
             this.communicateList();
           }
           }
        })
        .catch()
        .finally();
    },
    // 选择人员
    select(val) {
      this.selectData = val;
      this.selectPeople = ''
      this.tableData1 = []
      this.page1 = 1
      this.listNum = 0
      this.hasMore = true
      this.loading = false
      if (this.activeName == '0' || this.activeName == '1') {
        if(this.selectData.imType == 0){
          this.loadMore()
        }else{
          this.communicateList();
        }
      } else {
        this.clock();
      }
    },
    // 人员沟通记录
    communicateList() {
      let param = {
        page: this.page1,
        pageSize: this.pageSize1,
        imType: this.selectData.imType,
        bizMemberId:this.selectPeople,
        bizId: this.selectData.imType == 0?this.selectData.bodyguardId:this.selectData.id,
        jobNo: this.detail.jobNo
      };
      this.$axios
        .post(`/admapi/job/chatlist`, param)
        .then(({ data }) => {
          let arr = data.items;
          this.listNum = data.page.totalRows;
          for (var i = 0; i < arr.length; i++) {
            arr[i].message = JSON.parse(arr[i].message);
          }
          this.tableData1 = arr;

        })
        .catch()
        .finally();
    },
    // 人员打卡记录
    clock() {
      if(this.activeName1 == 0 || this.activeName1 == 2 || this.selectData.imType == 1){
        this.tableData2 = []
         return
      }
      let param = {
        bodyguardId: this.selectData.bodyguardId,
        jobNo: this.selectData.jobNo
      };
      this.$axios
        .post(`/admapi/job/signlist`, param)
        .then(({ data }) => {
          this.tableData2 = data;
        })
        .catch()
        .finally();
    },
    getSignStatusName(val) {
      //签到时间打卡类型:0-未打卡, 1-正常打卡, -1迟到打卡, -2早退打卡
      let name = "<span style='color:gray'>未打卡</span>";
      switch(val) {
        case 1 :
          name = "<span style='color:green'>正常打卡<span>";
          break;
        case -1:
          name =  "<span style='color:orange'>迟到打卡<span>";
          break;
        case -2:
          name = "<span style='color:orange'>早退打卡<span>";
          break;
        case -3:
          name = "<span style='color:orange'>旷工<span>";
          break;
      }

      return name;
    }
  }
};
</script>
<style scoped>
.detail {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.itemBox {
  width: 33.333%;
  min-height: 80vh;
  border-right: 1px solid #ccc;
}
.modelTitle {
  border-left: solid 5px #165dff;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
}
.iemBoxContent {
  min-height: 1720px;
  padding: 0 20px;
  box-sizing: border-box;
}
.infoItem {
  display: flex;
  align-items: center;

  color: #4f4b4b;
  margin-bottom: 20px;
}
.infoTitle {
  color: #000;
  flex: none;
}
.listItem {
  display: flex;
  /* justify-content: space-between; */
  padding: 10px 10px;
  box-sizing: border-box;
  align-items: center;
  background: #f3f2f2;
  margin-top: 10px;
}
.img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 20px;
  flex: none;
}
.img img {
  width: 100%;
  height: 100%;
}
.active {
  background: #165dff;
  color: #fff;
}
.message {
  padding: 10px 10px;
  border: #ccc 1px solid;
  margin-top: 8px;
}
.communicate {
  margin-bottom: 20px;
}
.borderBottom {
  width: 100%;
  height: 2px;
  border-bottom: #ccc 1px dotted;
  margin-bottom: 20px;
}
.select {
  width: 10px;
  height: 10px;
  background: #165dff;
  border-radius: 10px;
}
.noselect {
  width: 10px;
  height: 10px;
  border: #165dff 1px solid;
  border-radius: 10px;
}
.el-timeline{
  padding-inline-start: 7px;
}
.daka{
height: 100%;
overflow-y: scroll;
}
.daka::-webkit-scrollbar {
  display: none;
}
/* /deep/ .el-timeline-item__wrapper{
  width: 90% !important;
  padding-left: 20px !important;
}  */
.pointer {
  cursor: pointer;
}
.boxContent {
  display: flex;
  border: 1px solid #ccc;
}
.chat {
  height: 60vh;
  /* overflow-y: scroll; */
  padding: 20px;
  box-sizing: border-box;
  overflow: auto;
}
.send {
  height: 150px;
  padding: 10px 20px;
  box-sizing: border-box;
  display: flex;
  border-top: 1px solid #ccc;
  justify-content: end;
}
.noSend {
  height: 77vh;
}

.listTile {
  padding: 20px 10px;
  box-sizing: border-box;
  background: #165dff;
  color: #fff;
  font-weight: 600;
  font-size: 18px;
}
.userItem {
  cursor: pointer;
  padding: 20px 15px;
  box-sizing: border-box;
  border-bottom: #ccc 1px solid;
  display: flex;
  align-items: center;
  position: relative;
}
.ueserSelect {
  background: #9cb3eb;
  color: #fff;
}
.userImg {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  flex: none;
}
.userImg img {
  width: 100%;
  height: 100%;
}
.num {
  height: 20px;
  flex: none;
  text-align: center;
  border-radius: 8px;
  padding: 0 6px;
  background: red;
  box-sizing: border-box;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  position: absolute;
  top: 10px;
  left: 30px;
}
.chatItem {
  width: 100%;
  margin: 20px 0;
}
.userInfo {
  display: flex;
  align-items: center;
}
.userInfo1 {
  display: flex;
  align-items: center;
  justify-content: end;
}
.chatImg {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
}
.chatImg img {
  width: 100%;
  height: 100%;
}
.userchat {
  padding-left: 60px;
  box-sizing: border-box;
  margin-top: 10px;
}
.userchat1 {
  display: flex;
  justify-content: end;
  padding-right: 60px;
  box-sizing: border-box;
  margin-top: 10px;
}
.box-card {
  max-width: 300px;
  background: #e1dede;
  padding: 10px 10px;
  height: auto;
  border-radius: 8px;
  overflow-wrap: anywhere;
  display: inline-block;
}
.box-card img {
  width: 200px;
  height: 200px;
}
.box-card1 {
  width: 300px;
  font-size: 12px;
  color: #165dff;
  text-align: left;
}
.cardTop {
  display: flex;
  justify-content: space-between;
  justify-items: center;
}
.cardStatus {
  padding: 1px 2px;
  color: rgb(43, 233, 169);
  border: 1px solid rgb(43, 233, 169);
  font-size: 12px;
  flex: none;
}
.cardNum {
  flex: none;
  color: rgb(240, 176, 27);
}
</style>
